import React from "react";
import { Hero } from "@/components/sections/Hero";
import { SloganStrip } from "@/components/sections/SloganStrip";
import { AboutMissionVision } from "@/components/sections/AboutMissionVision";
import { ImpactCounters } from "@/components/sections/ImpactCounters";
import { ProgramsGrid } from "@/components/sections/ProgramsGrid";
import { FeaturedCampaigns } from "@/components/sections/FeaturedCampaigns";
import { TransparencyStrip } from "@/components/sections/TransparencyStrip";
import { ImpactCalculator } from "@/components/sections/ImpactCalculator";
import { LatestNews } from "@/components/sections/LatestNews";
import { SuccessStories } from "@/components/sections/SuccessStories";
import { GallerySection } from "@/components/sections/GallerySection";
import { VideoSection } from "@/components/sections/VideoSection";
import { TestimonialsCarousel } from "@/components/sections/TestimonialsCarousel";
import { VolunteerSection } from "@/components/sections/VolunteerSection";
import { DonateSection } from "@/components/sections/DonateSection";
import { DonorWall } from "@/components/sections/DonorWall";
import { ReportIssueSection } from "@/components/sections/ReportIssueSection";
import { CSRSection } from "@/components/sections/CSRSection";
import { TeamGrid } from "@/components/sections/TeamGrid";
import { FAQSection } from "@/components/sections/FAQSection";
import { ContactSection } from "@/components/sections/ContactSection";
import { PartnersStrip } from "@/components/sections/PartnersStrip";
import { CTABand } from "@/components/sections/CTABand";
import { SEO } from "@/lib/seo";

export default function HomePage() {
  return (
    <main>
      <SEO title="Building Aware Citizens, Responsible Nation" description="Citizen Awareness Foundation (CAF) is a Section 8 non-profit driving awareness, transparency and civic action across India — disaster relief, education, health, environment and consumer rights." />
      <Hero />
      <SloganStrip />
      <AboutMissionVision />
      <ImpactCounters />
      <ProgramsGrid />
      <FeaturedCampaigns />
      <TransparencyStrip />
      <ImpactCalculator />
      <LatestNews />
      <SuccessStories />
      <GallerySection />
      <VideoSection />
      <TestimonialsCarousel />
      <VolunteerSection />
      <DonateSection />
      <DonorWall />
      <ReportIssueSection />
      <CSRSection />
      <TeamGrid />
      <FAQSection />
      <PartnersStrip />
      <CTABand />
      <ContactSection />
    </main>
  );
}
